/** Ключ запроса объявлений превью в cancellationTokenManager: новый выбор пина и закрытие превью отменяют текущий. */
export const PREVIEW_OFFERS_REQUEST_KEY = 'previewOffers';
